import { LitElement, html, css } from './-global.min.js';

class MtnProductGrid extends LitElement {
    static properties = {
        productHandle: {
            type: String,
            attribute: 'data-product-handle'
        },
        product: {
            type: Object
        }
    };

    static styles = css`
    .product-artists {
        font-size: 12px;
        font-weight: 400;
        line-height: 1.5;
        color: #666;
        margin: 5px 0 0 0;
    }
  `;

    constructor() {
        super();
        this.product = {};
        this.accessToken = "e4c9e63cefc7836262ccdbe8b7dde110";
    }

    connectedCallback() {
        super.connectedCallback();
        // console.log(this.productHandle);
        this.fetchProducts().then(r => r);
    }

    async fetchProducts() {
        const query = `
        {
            productByHandle(handle: "${this.productHandle}") {
              id
              artists: metafield(namespace: "mtn", key:"artists") {
                id
                references(first: 10) {
                  edges {
                    node {
                      __typename
                      ... on Metaobject {
                        fields {
                          key
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
        }
        `;

        const response = await fetch('https://mutingthenoise.myshopify.com/api/2024-04/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': this.accessToken
            },
            body: JSON.stringify({ query })
        });
        const responseBody = await response.json();
        this.product = responseBody.data;
    }

    render() {
        if (!this.product.productByHandle || !this.product.productByHandle.artists) {
            return html`<span>Loading...</span>`;
        }

        return html`
            ${this.product.productByHandle.artists.references.edges.map((artist, index, array) => {
                const name = artist.node.fields.find(field => field.key === 'name').value;
                return html`${name}${index < array.length - 1 ? ', ' : ''}`;
            })}
        `;
    }
}

customElements.define('mtn-product-artist', MtnProductGrid);
